import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Tooltip } from 'antd'
import css from '../../common/Form.css'

const explanation = {
  'Reminders Tier 2':
  <ul>
    <li>custom message settings</li>
    <li>eligible for custom post (must also be c9, access is granted in frontend)</li>
    <li>appt reminders go to a second contact if they exist</li>
    <li>allows incoming and outgoing messages with images</li>
    <li>blasts get &quot;more options&quot; button (filter by appt types)</li>
    <li>patient page gets second reminder phone and email buttons</li>
  </ul>,
  'topsReminders+':
  <ul>
    <li>includes reviews</li>
    <li>custom message settings</li>
  </ul>,
}

const ProductPicker = ({ checked, label, onChange, value, enabled }) => (
  <Tooltip
    title={explanation[label]}
    placement="topLeft"
    mouseEnterDelay="0.5"
    arrowPointAtCenter
  >
    <Checkbox
      value={value}
      onChange={onChange}
      checked={checked}
      className={css.label}
      disabled={!enabled}
    >
      {label}
    </Checkbox>
  </Tooltip>
)

ProductPicker.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
}

export default ProductPicker



// WEBPACK FOOTER //
// ./src/AddPractice/Products/ProductPicker.js